import { render, staticRenderFns } from "./ManLoadsCube.vue?vue&type=template&id=529274fe&scoped=true&"
import script from "./ManLoadsCube.vue?vue&type=script&lang=js&"
export * from "./ManLoadsCube.vue?vue&type=script&lang=js&"
import style0 from "./ManLoadsCube.vue?vue&type=style&index=0&id=529274fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529274fe",
  null
  
)

export default component.exports